module.exports = __webpack_public_path__ + "media/Components/fonts/Kameron-bb48f1f7044942b0e6b366c3942d4065.ttf";